webpackJsonp([10],{

/***/ "1kZT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__board_list__ = __webpack_require__("C5Ex");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__board_blank_state__ = __webpack_require__("rP25");
/* eslint-disable comma-dangle, space-before-function-paren, one-var */
/* global Sortable */




__webpack_require__("unKI");
__webpack_require__("C5Ex");

var Store = gl.issueBoards.BoardsStore;

window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.Board = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: '#js-board-template',
  components: {
    boardList: __WEBPACK_IMPORTED_MODULE_1__board_list__["default"],
    'board-delete': gl.issueBoards.BoardDelete,
    boardBlankState: __WEBPACK_IMPORTED_MODULE_2__board_blank_state__["a" /* default */]
  },
  props: {
    list: Object,
    disabled: Boolean,
    issueLinkBase: String,
    rootPath: String
  },
  data: function data() {
    return {
      detailIssue: Store.detail,
      filter: Store.filter
    };
  },

  watch: {
    filter: {
      handler: function handler() {
        this.list.page = 1;
        this.list.getIssues(true).catch(function () {
          // TODO: handle request error
        });
      },

      deep: true
    },
    detailIssue: {
      handler: function handler() {
        if (!Object.keys(this.detailIssue.issue).length) return;

        var issue = this.list.findIssue(this.detailIssue.issue.id);

        if (issue) {
          var offsetLeft = this.$el.offsetLeft;
          var boardsList = document.querySelectorAll('.boards-list')[0];
          var left = boardsList.scrollLeft - offsetLeft;
          var right = offsetLeft + this.$el.offsetWidth;

          if (window.innerWidth > 768 && boardsList.classList.contains('is-compact')) {
            // -290 here because width of boardsList is animating so therefore
            // getting the width here is incorrect
            // 290 is the width of the sidebar
            right -= boardsList.offsetWidth - 290;
          } else {
            right -= boardsList.offsetWidth;
          }

          if (right - boardsList.scrollLeft > 0) {
            $(boardsList).animate({
              scrollLeft: right
            }, this.sortableOptions.animation);
          } else if (left > 0) {
            $(boardsList).animate({
              scrollLeft: offsetLeft
            }, this.sortableOptions.animation);
          }
        }
      },

      deep: true
    }
  },
  methods: {
    showNewIssueForm: function showNewIssueForm() {
      this.$refs['board-list'].showIssueForm = !this.$refs['board-list'].showIssueForm;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.sortableOptions = gl.issueBoards.getBoardSortableDefaultOptions({
      disabled: this.disabled,
      group: 'boards',
      draggable: '.is-draggable',
      handle: '.js-board-handle',
      onEnd: function onEnd(e) {
        gl.issueBoards.onEnd();

        if (e.newIndex !== undefined && e.oldIndex !== e.newIndex) {
          var order = _this.sortable.toArray();
          var list = Store.findList('id', parseInt(e.item.dataset.id, 10));

          _this.$nextTick(function () {
            Store.moveList(list, order);
          });
        }
      }
    });

    this.sortable = Sortable.create(this.$el.parentNode, this.sortableOptions);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "3FuG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__ = __webpack_require__("9aVq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sidebar_components_assignees_assignee_title__ = __webpack_require__("DrL9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sidebar_components_assignees_assignees__ = __webpack_require__("ypBK");
/* eslint-disable comma-dangle, space-before-function-paren, no-new */
/* global IssuableContext */
/* global MilestoneSelect */
/* global LabelsSelect */
/* global Sidebar */
/* global Flash */







__webpack_require__("IOf9");

var Store = gl.issueBoards.BoardsStore;

window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.BoardSidebar = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    currentUser: Object
  },
  data: function data() {
    return {
      detail: Store.detail,
      issue: {},
      list: {},
      loadingAssignees: false
    };
  },

  computed: {
    showSidebar: function showSidebar() {
      return Object.keys(this.issue).length;
    },
    assigneeId: function assigneeId() {
      return this.issue.assignee ? this.issue.assignee.id : 0;
    }
  },
  watch: {
    detail: {
      handler: function handler() {
        var _this = this;

        if (this.issue.id !== this.detail.issue.id) {
          $('.block.assignee').find('input:not(.js-vue)[name="issue[assignee_ids][]"]').each(function (i, el) {
            $(el).remove();
          });

          $('.js-issue-board-sidebar', this.$el).each(function (i, el) {
            $(el).data('glDropdown').clearMenu();
          });
        }

        this.issue = this.detail.issue;
        this.list = this.detail.list;

        this.$nextTick(function () {
          _this.endpoint = _this.$refs.assigneeDropdown.dataset.issueUpdate;
        });
      },

      deep: true
    },
    issue: function issue() {
      if (this.showSidebar) {
        this.$nextTick(function () {
          $('.right-sidebar').getNiceScroll(0).doScrollTop(0, 0);
          $('.right-sidebar').getNiceScroll().resize();
        });
      }

      this.issue = this.detail.issue;
      this.list = this.detail.list;
    },

    deep: true
  },
  methods: {
    closeSidebar: function closeSidebar() {
      this.detail.issue = {};
    },
    assignSelf: function assignSelf() {
      // Notify gl dropdown that we are now assigning to current user
      this.$refs.assigneeBlock.dispatchEvent(new Event('assignYourself'));

      this.addAssignee(this.currentUser);
      this.saveAssignees();
    },
    removeAssignee: function removeAssignee(a) {
      gl.issueBoards.BoardsStore.detail.issue.removeAssignee(a);
    },
    addAssignee: function addAssignee(a) {
      gl.issueBoards.BoardsStore.detail.issue.addAssignee(a);
    },
    removeAllAssignees: function removeAllAssignees() {
      gl.issueBoards.BoardsStore.detail.issue.removeAllAssignees();
    },
    saveAssignees: function saveAssignees() {
      var _this2 = this;

      this.loadingAssignees = true;

      gl.issueBoards.BoardsStore.detail.issue.update(this.endpoint).then(function () {
        _this2.loadingAssignees = false;
      }).catch(function () {
        _this2.loadingAssignees = false;
        return new Flash('An error occurred while saving assignees');
      });
    }
  },
  created: function created() {
    // Get events from glDropdown
    __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__["a" /* default */].$on('sidebar.removeAssignee', this.removeAssignee);
    __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__["a" /* default */].$on('sidebar.addAssignee', this.addAssignee);
    __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__["a" /* default */].$on('sidebar.removeAllAssignees', this.removeAllAssignees);
    __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__["a" /* default */].$on('sidebar.saveAssignees', this.saveAssignees);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__["a" /* default */].$off('sidebar.removeAssignee', this.removeAssignee);
    __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__["a" /* default */].$off('sidebar.addAssignee', this.addAssignee);
    __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__["a" /* default */].$off('sidebar.removeAllAssignees', this.removeAllAssignees);
    __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__["a" /* default */].$off('sidebar.saveAssignees', this.saveAssignees);
  },
  mounted: function mounted() {
    new IssuableContext(this.currentUser);
    new MilestoneSelect();
    new gl.DueDateSelectors();
    new LabelsSelect();
    new Sidebar();
    gl.Subscription.bindAll('.subscription');
  },

  components: {
    removeBtn: gl.issueBoards.RemoveIssueBtn,
    'assignee-title': __WEBPACK_IMPORTED_MODULE_2__sidebar_components_assignees_assignee_title__["a" /* default */],
    assignees: __WEBPACK_IMPORTED_MODULE_3__sidebar_components_assignees_assignees__["a" /* default */]
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "9/oB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */
var container = document;

var FilteredSearchContainerClass = function () {
  function FilteredSearchContainerClass() {
    _classCallCheck(this, FilteredSearchContainerClass);
  }

  _createClass(FilteredSearchContainerClass, [{
    key: "container",
    set: function set(containerParam) {
      container = containerParam;
    },
    get: function get() {
      return container;
    }
  }]);

  return FilteredSearchContainerClass;
}();

/* harmony default export */ __webpack_exports__["a"] = (new FilteredSearchContainerClass());

/***/ }),

/***/ "9aVq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");


var eventHub = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

// TODO: remove eventHub hack after code splitting refactor
window.emitSidebarEvent = function () {
  return eventHub.$emit.apply(eventHub, arguments);
};

/* harmony default export */ __webpack_exports__["a"] = (eventHub);

/***/ }),

/***/ "9rP8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eventhub__ = __webpack_require__("p52B");
/* global ListIssue */


var Store = gl.issueBoards.BoardsStore;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BoardNewIssue',
  props: {
    list: Object
  },
  data: function data() {
    return {
      title: '',
      error: false
    };
  },

  methods: {
    submit: function submit(e) {
      var _this = this;

      e.preventDefault();
      if (this.title.trim() === '') return;

      this.error = false;

      var labels = this.list.label ? [this.list.label] : [];
      var issue = new ListIssue({
        title: this.title,
        labels: labels,
        subscribed: true,
        assignees: []
      });

      this.list.newIssue(issue).then(function () {
        // Need this because our jQuery very kindly disables buttons on ALL form submissions
        $(_this.$refs.submitButton).enable();

        Store.detail.issue = issue;
        Store.detail.list = _this.list;
      }).catch(function () {
        // Need this because our jQuery very kindly disables buttons on ALL form submissions
        $(_this.$refs.submitButton).enable();

        // Remove the issue
        _this.list.removeIssue(issue);

        // Show error message
        _this.error = true;
      });

      this.cancel();
    },
    cancel: function cancel() {
      this.title = '';
      __WEBPACK_IMPORTED_MODULE_0__eventhub__["a" /* default */].$emit('hide-issue-form-' + this.list.id);
    }
  },
  mounted: function mounted() {
    this.$refs.input.focus();
  },

  template: '\n    <div class="card board-new-issue-form">\n      <form @submit="submit($event)">\n        <div class="flash-container"\n          v-if="error">\n          <div class="flash-alert">\n            An error occured. Please try again.\n          </div>\n        </div>\n        <label class="label-light"\n          :for="list.id + \'-title\'">\n          Title\n        </label>\n        <input class="form-control"\n          type="text"\n          v-model="title"\n          ref="input"\n          :id="list.id + \'-title\'" />\n        <div class="clearfix prepend-top-10">\n          <button class="btn btn-success pull-left"\n            type="submit"\n            :disabled="title === \'\'"\n            ref="submit-button">\n            Submit issue\n          </button>\n          <button class="btn btn-default pull-right"\n            type="button"\n            @click="cancel">\n            Cancel\n          </button>\n        </div>\n      </form>\n    </div>\n  '
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "AN7F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (path, extraData) {
  return path.split('&').reduce(function (dataParam, filterParam) {
    if (filterParam === '') return dataParam;

    var data = dataParam;
    var paramSplit = filterParam.split('=');
    var paramKeyNormalized = paramSplit[0].replace('[]', '');
    var isArray = paramSplit[0].indexOf('[]');
    var value = decodeURIComponent(paramSplit[1]).replace(/\+/g, ' ');

    if (isArray !== -1) {
      if (!data[paramKeyNormalized]) {
        data[paramKeyNormalized] = [];
      }

      data[paramKeyNormalized].push(value);
    } else {
      data[paramKeyNormalized] = value;
    }

    return data;
  }, extraData);
});

/***/ }),

/***/ "AX9H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filters__ = __webpack_require__("rFKb");



__webpack_require__("EVjf");

var ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalHeader = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  mixins: [gl.issueBoards.ModalMixins],
  props: {
    projectId: {
      type: Number,
      required: true
    },
    milestonePath: {
      type: String,
      required: true
    },
    labelPath: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return ModalStore.store;
  },

  computed: {
    selectAllText: function selectAllText() {
      if (ModalStore.selectedCount() !== this.issues.length || this.issues.length === 0) {
        return 'Select all';
      }

      return 'Deselect all';
    },
    showSearch: function showSearch() {
      return this.activeTab === 'all' && !this.loading && this.issuesCount > 0;
    }
  },
  methods: {
    toggleAll: function toggleAll() {
      this.$refs.selectAllBtn.blur();

      ModalStore.toggleAll();
    }
  },
  components: {
    'modal-tabs': gl.issueBoards.ModalTabs,
    modalFilters: __WEBPACK_IMPORTED_MODULE_1__filters__["a" /* default */]
  },
  template: '\n    <div>\n      <header class="add-issues-header form-actions">\n        <h2>\n          Add issues\n          <button\n            type="button"\n            class="close"\n            data-dismiss="modal"\n            aria-label="Close"\n            @click="toggleModal(false)">\n            <span aria-hidden="true">\xD7</span>\n          </button>\n        </h2>\n      </header>\n      <modal-tabs v-if="!loading && issuesCount > 0"></modal-tabs>\n      <div\n        class="add-issues-search append-bottom-10"\n        v-if="showSearch">\n        <modal-filters :store="filter" />\n        <button\n          type="button"\n          class="btn btn-success btn-inverted prepend-left-10"\n          ref="selectAllBtn"\n          @click="toggleAll">\n          {{ selectAllText }}\n        </button>\n      </div>\n    </div>\n  '
});

/***/ }),

/***/ "C5Ex":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__board_new_issue__ = __webpack_require__("9rP8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__board_card__ = __webpack_require__("qqgg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eventhub__ = __webpack_require__("p52B");
/* global Sortable */




var Store = gl.issueBoards.BoardsStore;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BoardList',
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    list: {
      type: Object,
      required: true
    },
    issues: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    issueLinkBase: {
      type: String,
      required: true
    },
    rootPath: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      scrollOffset: 250,
      filters: Store.state.filters,
      showCount: false,
      showIssueForm: false
    };
  },

  components: {
    boardCard: __WEBPACK_IMPORTED_MODULE_1__board_card__["a" /* default */],
    boardNewIssue: __WEBPACK_IMPORTED_MODULE_0__board_new_issue__["a" /* default */]
  },
  methods: {
    listHeight: function listHeight() {
      return this.$refs.list.getBoundingClientRect().height;
    },
    scrollHeight: function scrollHeight() {
      return this.$refs.list.scrollHeight;
    },
    scrollTop: function scrollTop() {
      return this.$refs.list.scrollTop + this.listHeight();
    },
    loadNextPage: function loadNextPage() {
      var _this = this;

      var getIssues = this.list.nextPage();
      var loadingDone = function loadingDone() {
        _this.list.loadingMore = false;
      };

      if (getIssues) {
        this.list.loadingMore = true;
        getIssues.then(loadingDone).catch(loadingDone);
      }
    },
    toggleForm: function toggleForm() {
      this.showIssueForm = !this.showIssueForm;
    },
    onScroll: function onScroll() {
      if (this.scrollTop() > this.scrollHeight() - this.scrollOffset && !this.list.loadingMore) {
        this.loadNextPage();
      }
    }
  },
  watch: {
    filters: {
      handler: function handler() {
        this.list.loadingMore = false;
        this.$refs.list.scrollTop = 0;
      },

      deep: true
    },
    issues: function issues() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.scrollHeight() <= _this2.listHeight() && _this2.list.issuesSize > _this2.list.issues.length) {
          _this2.list.page += 1;
          _this2.list.getIssues(false).catch(function () {
            // TODO: handle request error
          });
        }

        if (_this2.scrollHeight() > Math.ceil(_this2.listHeight())) {
          _this2.showCount = true;
        } else {
          _this2.showCount = false;
        }
      });
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_2__eventhub__["a" /* default */].$on('hide-issue-form-' + this.list.id, this.toggleForm);
  },
  mounted: function mounted() {
    var _this3 = this;

    var options = gl.issueBoards.getBoardSortableDefaultOptions({
      scroll: document.querySelectorAll('.boards-list')[0],
      group: 'issues',
      disabled: this.disabled,
      filter: '.board-list-count, .is-disabled',
      dataIdAttr: 'data-issue-id',
      onStart: function onStart(e) {
        var card = _this3.$refs.issue[e.oldIndex];

        card.showDetail = false;
        Store.moving.list = card.list;
        Store.moving.issue = Store.moving.list.findIssue(+e.item.dataset.issueId);

        gl.issueBoards.onStart();
      },
      onAdd: function onAdd(e) {
        gl.issueBoards.BoardsStore.moveIssueToList(Store.moving.list, _this3.list, Store.moving.issue, e.newIndex);

        _this3.$nextTick(function () {
          e.item.remove();
        });
      },
      onUpdate: function onUpdate(e) {
        var sortedArray = _this3.sortable.toArray().filter(function (id) {
          return id !== '-1';
        });
        gl.issueBoards.BoardsStore.moveIssueInList(_this3.list, Store.moving.issue, e.oldIndex, e.newIndex, sortedArray);
      },
      onMove: function onMove(e) {
        return !e.related.classList.contains('board-list-count');
      }
    });

    this.sortable = Sortable.create(this.$refs.list, options);

    // Scroll event on list to load more
    this.$refs.list.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__eventhub__["a" /* default */].$off('hide-issue-form-' + this.list.id, this.toggleForm);
    this.$refs.list.removeEventListener('scroll', this.onScroll);
  },

  template: '\n    <div class="board-list-component">\n      <div\n        class="board-list-loading text-center"\n        aria-label="Loading issues"\n        v-if="loading">\n        <i\n          class="fa fa-spinner fa-spin"\n          aria-hidden="true">\n        </i>\n      </div>\n      <board-new-issue\n        :list="list"\n        v-if="list.type !== \'closed\' && showIssueForm"/>\n      <ul\n        class="board-list"\n        v-show="!loading"\n        ref="list"\n        :data-board="list.id"\n        :class="{ \'is-smaller\': showIssueForm }">\n        <board-card\n          v-for="(issue, index) in issues"\n          ref="issue"\n          :index="index"\n          :list="list"\n          :issue="issue"\n          :issue-link-base="issueLinkBase"\n          :root-path="rootPath"\n          :disabled="disabled"\n          :key="issue.id" />\n        <li\n          class="board-list-count text-center"\n          v-if="showCount"\n          data-id="-1">\n          <i\n            class="fa fa-spinner fa-spin"\n            aria-label="Loading more issues"\n            aria-hidden="true"\n            v-show="list.loadingMore">\n          </i>\n          <span v-if="list.issues.length === list.issuesSize">\n            Showing all issues\n          </span>\n          <span v-else>\n            Showing {{ list.issues.length }} of {{ list.issuesSize }} issues\n          </span>\n        </li>\n      </ul>\n    </div>\n  '
});

/***/ }),

/***/ "DV+M":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-unused-vars */

var ListMilestone = function ListMilestone(obj) {
  _classCallCheck(this, ListMilestone);

  this.id = obj.id;
  this.title = obj.title;
};

window.ListMilestone = ListMilestone;

/***/ }),

/***/ "DrL9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AssigneeTitle',
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    numberOfAssignees: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    assigneeTitle: function assigneeTitle() {
      var assignees = this.numberOfAssignees;
      return assignees > 1 ? assignees + ' Assignees' : 'Assignee';
    }
  },
  template: '\n    <div class="title hide-collapsed">\n      {{assigneeTitle}}\n      <i\n        v-if="loading"\n        aria-hidden="true"\n        class="fa fa-spinner fa-spin block-loading"\n      />\n      <a\n        v-if="editable"\n        class="edit-link pull-right"\n        href="#"\n      >\n        Edit\n      </a>\n    </div>\n  '
});

/***/ }),

/***/ "EVjf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");


var ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalTabs = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  mixins: [gl.issueBoards.ModalMixins],
  data: function data() {
    return ModalStore.store;
  },

  computed: {
    selectedCount: function selectedCount() {
      return ModalStore.selectedCount();
    }
  },
  destroyed: function destroyed() {
    this.activeTab = 'all';
  },

  template: '\n    <div class="top-area prepend-top-10 append-bottom-10">\n      <ul class="nav-links issues-state-filters">\n        <li :class="{ \'active\': activeTab == \'all\' }">\n          <a\n            href="#"\n            role="button"\n            @click.prevent="changeTab(\'all\')">\n            Open issues\n            <span class="badge">\n              {{ issuesCount }}\n            </span>\n          </a>\n        </li>\n        <li :class="{ \'active\': activeTab == \'selected\' }">\n          <a\n            href="#"\n            role="button"\n            @click.prevent="changeTab(\'selected\')">\n            Selected issues\n            <span class="badge">\n              {{ selectedCount }}\n            </span>\n          </a>\n        </li>\n      </ul>\n    </div>\n  '
});

/***/ }),

/***/ "HsL0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable space-before-function-paren, comma-dangle, no-param-reassign, camelcase, max-len, no-unused-vars */



var BoardService = function () {
  function BoardService(root, bulkUpdatePath, boardId) {
    _classCallCheck(this, BoardService);

    this.boards = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].resource(root + '{/id}.json', {}, {
      issues: {
        method: 'GET',
        url: root + '/' + boardId + '/issues.json'
      }
    });
    this.lists = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].resource(root + '/' + boardId + '/lists{/id}', {}, {
      generate: {
        method: 'POST',
        url: root + '/' + boardId + '/lists/generate.json'
      }
    });
    this.issue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].resource(root + '/' + boardId + '/issues{/id}', {});
    this.issues = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].resource(root + '/' + boardId + '/lists{/id}/issues', {}, {
      bulkUpdate: {
        method: 'POST',
        url: bulkUpdatePath
      }
    });

    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
      request.headers['X-CSRF-Token'] = $.rails.csrfToken();
      next();
    });
  }

  _createClass(BoardService, [{
    key: 'all',
    value: function all() {
      return this.lists.get();
    }
  }, {
    key: 'generateDefaultLists',
    value: function generateDefaultLists() {
      return this.lists.generate({});
    }
  }, {
    key: 'createList',
    value: function createList(label_id) {
      return this.lists.save({}, {
        list: {
          label_id: label_id
        }
      });
    }
  }, {
    key: 'updateList',
    value: function updateList(id, position) {
      return this.lists.update({ id: id }, {
        list: {
          position: position
        }
      });
    }
  }, {
    key: 'destroyList',
    value: function destroyList(id) {
      return this.lists.delete({ id: id });
    }
  }, {
    key: 'getIssuesForList',
    value: function getIssuesForList(id) {
      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var data = { id: id };
      Object.keys(filter).forEach(function (key) {
        data[key] = filter[key];
      });

      return this.issues.get(data);
    }
  }, {
    key: 'moveIssue',
    value: function moveIssue(id) {
      var from_list_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var to_list_id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var move_before_iid = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var move_after_iid = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      return this.issue.update({ id: id }, {
        from_list_id: from_list_id,
        to_list_id: to_list_id,
        move_before_iid: move_before_iid,
        move_after_iid: move_after_iid
      });
    }
  }, {
    key: 'newIssue',
    value: function newIssue(id, issue) {
      return this.issues.save({ id: id }, {
        issue: issue
      });
    }
  }, {
    key: 'getBacklog',
    value: function getBacklog(data) {
      return this.boards.issues(data);
    }
  }, {
    key: 'bulkUpdate',
    value: function bulkUpdate(issueIds) {
      var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var data = {
        update: Object.assign(extraData, {
          issuable_ids: issueIds.join(',')
        })
      };

      return this.issues.bulkUpdate(data);
    }
  }]);

  return BoardService;
}();

window.BoardService = BoardService;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "IOf9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* eslint-disable no-new */
/* global Flash */



var Store = gl.issueBoards.BoardsStore;

window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.RemoveIssueBtn = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    issue: {
      type: Object,
      required: true
    },
    list: {
      type: Object,
      required: true
    }
  },
  methods: {
    removeIssue: function removeIssue() {
      var issue = this.issue;
      var lists = issue.getLists();
      var labelIds = lists.map(function (list) {
        return list.label.id;
      });

      // Post the remove data
      gl.boardService.bulkUpdate([issue.globalId], {
        remove_label_ids: labelIds
      }).catch(function () {
        new Flash('Failed to remove issue from board, please try again.', 'alert');

        lists.forEach(function (list) {
          list.addIssue(issue);
        });
      });

      // Remove from the frontend store
      lists.forEach(function (list) {
        list.removeIssue(issue);
      });

      Store.detail.issue = {};
    }
  },
  template: '\n    <div\n      class="block list"\n      v-if="list.type !== \'closed\'">\n      <button\n        class="btn btn-default btn-block"\n        type="button"\n        @click="removeIssue">\n        Remove from board\n      </button>\n    </div>\n  '
});

/***/ }),

/***/ "IyBU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("7UJR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_resource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtered_search_boards__ = __webpack_require__("s61N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventhub__ = __webpack_require__("p52B");
/* eslint-disable one-var, quote-props, comma-dangle, space-before-function-paren */
/* global BoardService */
/* global Flash */






__webpack_require__("Xfhe");
__webpack_require__("Omkx");
__webpack_require__("K8NX");
__webpack_require__("DV+M");
__webpack_require__("Zuh3");
__webpack_require__("f7wA");
__webpack_require__("q4Fq");
__webpack_require__("HsL0");
__webpack_require__("aKLL");
__webpack_require__("TQdT");
__webpack_require__("qMC/");
__webpack_require__("1kZT");
__webpack_require__("3FuG");
__webpack_require__("dzNA");
__webpack_require__("lgdU");
__webpack_require__("wFzz");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource___default.a);

$(function () {
  var $boardApp = document.getElementById('board-app');
  var Store = gl.issueBoards.BoardsStore;
  var ModalStore = gl.issueBoards.ModalStore;

  window.gl = window.gl || {};

  if (gl.IssueBoardsApp) {
    gl.IssueBoardsApp.$destroy(true);
  }

  Store.create();

  // hack to allow sidebar scripts like milestone_select manipulate the BoardsStore
  gl.issueBoards.boardStoreIssueSet = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set.apply(__WEBPACK_IMPORTED_MODULE_0_vue__["default"], [Store.detail.issue].concat(args));
  };
  gl.issueBoards.boardStoreIssueDelete = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].delete.apply(__WEBPACK_IMPORTED_MODULE_0_vue__["default"], [Store.detail.issue].concat(args));
  };

  gl.IssueBoardsApp = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: $boardApp,
    components: {
      'board': gl.issueBoards.Board,
      'board-sidebar': gl.issueBoards.BoardSidebar,
      'board-add-issues-modal': gl.issueBoards.IssuesModal
    },
    data: {
      state: Store.state,
      loading: true,
      endpoint: $boardApp.dataset.endpoint,
      boardId: $boardApp.dataset.boardId,
      disabled: $boardApp.dataset.disabled === 'true',
      issueLinkBase: $boardApp.dataset.issueLinkBase,
      rootPath: $boardApp.dataset.rootPath,
      bulkUpdatePath: $boardApp.dataset.bulkUpdatePath,
      detailIssue: Store.detail,
      defaultAvatar: $boardApp.dataset.defaultAvatar
    },
    computed: {
      detailIssueVisible: function detailIssueVisible() {
        return Object.keys(this.detailIssue.issue).length;
      }
    },
    created: function created() {
      gl.boardService = new BoardService(this.endpoint, this.bulkUpdatePath, this.boardId);

      this.filterManager = new __WEBPACK_IMPORTED_MODULE_2__filtered_search_boards__["a" /* default */](Store.filter, true);

      // Listen for updateTokens event
      __WEBPACK_IMPORTED_MODULE_3__eventhub__["a" /* default */].$on('updateTokens', this.updateTokens);
    },
    beforeDestroy: function beforeDestroy() {
      __WEBPACK_IMPORTED_MODULE_3__eventhub__["a" /* default */].$off('updateTokens', this.updateTokens);
    },
    mounted: function mounted() {
      var _this = this;

      Store.disabled = this.disabled;
      gl.boardService.all().then(function (resp) {
        resp.json().forEach(function (board) {
          var list = Store.addList(board, _this.defaultAvatar);

          if (list.type === 'closed') {
            list.position = Infinity;
            list.label = { description: 'Shows all closed issues. Moving an issue to this list closes it' };
          }
        });

        _this.state.lists = _.sortBy(_this.state.lists, 'position');

        Store.addBlankState();
        _this.loading = false;
      }).catch(function () {
        return new Flash('An error occurred. Please try again.');
      });
    },

    methods: {
      updateTokens: function updateTokens() {
        this.filterManager.updateTokens();
      }
    }
  });

  gl.IssueBoardsSearch = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: document.getElementById('js-add-list'),
    data: {
      filters: Store.state.filters
    },
    mounted: function mounted() {
      gl.issueBoards.newListDropdownInit();
    }
  });

  gl.IssueBoardsModalAddBtn = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    mixins: [gl.issueBoards.ModalMixins],
    el: document.getElementById('js-add-issues-btn'),
    data: {
      modal: ModalStore.store,
      store: Store.state
    },
    watch: {
      disabled: function disabled() {
        this.updateTooltip();
      }
    },
    computed: {
      disabled: function disabled() {
        return !this.store.lists.filter(function (list) {
          return list.type !== 'blank' && list.type !== 'done';
        }).length;
      },
      tooltipTitle: function tooltipTitle() {
        if (this.disabled) {
          return 'Please add a list to your board first';
        }

        return '';
      }
    },
    methods: {
      updateTooltip: function updateTooltip() {
        var _this2 = this;

        var $tooltip = $(this.$el);

        this.$nextTick(function () {
          if (_this2.disabled) {
            $tooltip.tooltip();
          } else {
            $tooltip.tooltip('destroy');
          }
        });
      },
      openModal: function openModal() {
        if (!this.disabled) {
          this.toggleModal(true);
        }
      }
    },
    mounted: function mounted() {
      this.updateTooltip();
    },

    template: '\n      <button\n        class="btn btn-create pull-right prepend-left-10"\n        type="button"\n        data-placement="bottom"\n        :class="{ \'disabled\': disabled }"\n        :title="tooltipTitle"\n        :aria-disabled="disabled"\n        @click="openModal">\n        Add issues\n      </button>\n    '
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "K8NX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_query_data__ = __webpack_require__("AN7F");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable space-before-function-paren, no-underscore-dangle, class-methods-use-this, consistent-return, no-shadow, no-param-reassign, max-len, no-unused-vars */
/* global ListIssue */
/* global ListLabel */


var PER_PAGE = 20;

var List = function () {
  function List(obj, defaultAvatar) {
    _classCallCheck(this, List);

    this.id = obj.id;
    this._uid = this.guid();
    this.position = obj.position;
    this.title = obj.title;
    this.type = obj.list_type;
    this.preset = ['closed', 'blank'].indexOf(this.type) > -1;
    this.page = 1;
    this.loading = true;
    this.loadingMore = false;
    this.issues = [];
    this.issuesSize = 0;
    this.defaultAvatar = defaultAvatar;

    if (obj.label) {
      this.label = new ListLabel(obj.label);
    }

    if (this.type !== 'blank' && this.id) {
      this.getIssues().catch(function () {
        // TODO: handle request error
      });
    }
  }

  _createClass(List, [{
    key: 'guid',
    value: function guid() {
      var s4 = function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      };
      return '' + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }
  }, {
    key: 'save',
    value: function save() {
      var _this = this;

      return gl.boardService.createList(this.label.id).then(function (resp) {
        var data = resp.json();

        _this.id = data.id;
        _this.type = data.list_type;
        _this.position = data.position;

        return _this.getIssues();
      });
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var index = gl.issueBoards.BoardsStore.state.lists.indexOf(this);
      gl.issueBoards.BoardsStore.state.lists.splice(index, 1);
      gl.issueBoards.BoardsStore.updateNewListDropdown(this.id);

      gl.boardService.destroyList(this.id).catch(function () {
        // TODO: handle request error
      });
    }
  }, {
    key: 'update',
    value: function update() {
      gl.boardService.updateList(this.id, this.position).catch(function () {
        // TODO: handle request error
      });
    }
  }, {
    key: 'nextPage',
    value: function nextPage() {
      if (this.issuesSize > this.issues.length) {
        if (this.issues.length / PER_PAGE >= 1) {
          this.page += 1;
        }

        return this.getIssues(false);
      }
    }
  }, {
    key: 'getIssues',
    value: function getIssues() {
      var _this2 = this;

      var emptyIssues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_query_data__["a" /* default */])(gl.issueBoards.BoardsStore.filter.path, { page: this.page });

      if (this.label && data.label_name) {
        data.label_name = data.label_name.filter(function (label) {
          return label !== _this2.label.title;
        });
      }

      if (emptyIssues) {
        this.loading = true;
      }

      return gl.boardService.getIssuesForList(this.id, data).then(function (resp) {
        var data = resp.json();
        _this2.loading = false;
        _this2.issuesSize = data.size;

        if (emptyIssues) {
          _this2.issues = [];
        }

        _this2.createIssues(data.issues);
      });
    }
  }, {
    key: 'newIssue',
    value: function newIssue(issue) {
      this.addIssue(issue);
      this.issuesSize += 1;

      return gl.boardService.newIssue(this.id, issue).then(function (resp) {
        var data = resp.json();
        issue.id = data.iid;
      });
    }
  }, {
    key: 'createIssues',
    value: function createIssues(data) {
      var _this3 = this;

      data.forEach(function (issueObj) {
        _this3.addIssue(new ListIssue(issueObj, _this3.defaultAvatar));
      });
    }
  }, {
    key: 'addIssue',
    value: function addIssue(issue, listFrom, newIndex) {
      var moveBeforeIid = null;
      var moveAfterIid = null;

      if (!this.findIssue(issue.id)) {
        if (newIndex !== undefined) {
          this.issues.splice(newIndex, 0, issue);

          if (this.issues[newIndex - 1]) {
            moveBeforeIid = this.issues[newIndex - 1].id;
          }

          if (this.issues[newIndex + 1]) {
            moveAfterIid = this.issues[newIndex + 1].id;
          }
        } else {
          this.issues.push(issue);
        }

        if (this.label) {
          issue.addLabel(this.label);
        }

        if (listFrom) {
          this.issuesSize += 1;

          this.updateIssueLabel(issue, listFrom, moveBeforeIid, moveAfterIid);
        }
      }
    }
  }, {
    key: 'moveIssue',
    value: function moveIssue(issue, oldIndex, newIndex, moveBeforeIid, moveAfterIid) {
      this.issues.splice(oldIndex, 1);
      this.issues.splice(newIndex, 0, issue);

      gl.boardService.moveIssue(issue.id, null, null, moveBeforeIid, moveAfterIid).catch(function () {
        // TODO: handle request error
      });
    }
  }, {
    key: 'updateIssueLabel',
    value: function updateIssueLabel(issue, listFrom, moveBeforeIid, moveAfterIid) {
      gl.boardService.moveIssue(issue.id, listFrom.id, this.id, moveBeforeIid, moveAfterIid).catch(function () {
        // TODO: handle request error
      });
    }
  }, {
    key: 'findIssue',
    value: function findIssue(id) {
      return this.issues.filter(function (issue) {
        return issue.id === id;
      })[0];
    }
  }, {
    key: 'removeIssue',
    value: function removeIssue(_removeIssue) {
      var _this4 = this;

      this.issues = this.issues.filter(function (issue) {
        var matchesRemove = _removeIssue.id === issue.id;

        if (matchesRemove) {
          _this4.issuesSize -= 1;
          issue.removeLabel(_this4.label);
        }

        return !matchesRemove;
      });
    }
  }]);

  return List;
}();

window.List = List;

/***/ }),

/***/ "Omkx":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-unused-vars, space-before-function-paren */

var ListLabel = function ListLabel(obj) {
  _classCallCheck(this, ListLabel);

  this.id = obj.id;
  this.title = obj.title;
  this.color = obj.color;
  this.textColor = obj.text_color;
  this.description = obj.description;
  this.priority = obj.priority !== null ? obj.priority : Infinity;
};

window.ListLabel = ListLabel;

/***/ }),

/***/ "Pn7F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* global ListIssue */
/* global bp */



var ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalList = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    issueLinkBase: {
      type: String,
      required: true
    },
    rootPath: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return ModalStore.store;
  },

  watch: {
    activeTab: function activeTab() {
      if (this.activeTab === 'all') {
        ModalStore.purgeUnselectedIssues();
      }
    }
  },
  computed: {
    loopIssues: function loopIssues() {
      if (this.activeTab === 'all') {
        return this.issues;
      }

      return this.selectedIssues;
    },
    groupedIssues: function groupedIssues() {
      var _this = this;

      var groups = [];
      this.loopIssues.forEach(function (issue, i) {
        var index = i % _this.columns;

        if (!groups[index]) {
          groups.push([]);
        }

        groups[index].push(issue);
      });

      return groups;
    }
  },
  methods: {
    scrollHandler: function scrollHandler() {
      var currentPage = Math.floor(this.issues.length / this.perPage);

      if (this.scrollTop() > this.scrollHeight() - 100 && !this.loadingNewPage && currentPage === this.page) {
        this.loadingNewPage = true;
        this.page += 1;
      }
    },
    toggleIssue: function toggleIssue(e, issue) {
      if (e.target.tagName !== 'A') {
        ModalStore.toggleIssue(issue);
      }
    },
    listHeight: function listHeight() {
      return this.$refs.list.getBoundingClientRect().height;
    },
    scrollHeight: function scrollHeight() {
      return this.$refs.list.scrollHeight;
    },
    scrollTop: function scrollTop() {
      return this.$refs.list.scrollTop + this.listHeight();
    },
    showIssue: function showIssue(issue) {
      if (this.activeTab === 'all') return true;

      var index = ModalStore.selectedIssueIndex(issue);

      return index !== -1;
    },
    setColumnCount: function setColumnCount() {
      var breakpoint = bp.getBreakpointSize();

      if (breakpoint === 'lg' || breakpoint === 'md') {
        this.columns = 3;
      } else if (breakpoint === 'sm') {
        this.columns = 2;
      } else {
        this.columns = 1;
      }
    }
  },
  mounted: function mounted() {
    this.scrollHandlerWrapper = this.scrollHandler.bind(this);
    this.setColumnCountWrapper = this.setColumnCount.bind(this);
    this.setColumnCount();

    this.$refs.list.addEventListener('scroll', this.scrollHandlerWrapper);
    window.addEventListener('resize', this.setColumnCountWrapper);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.list.removeEventListener('scroll', this.scrollHandlerWrapper);
    window.removeEventListener('resize', this.setColumnCountWrapper);
  },

  components: {
    'issue-card-inner': gl.issueBoards.IssueCardInner
  },
  template: '\n    <section\n      class="add-issues-list add-issues-list-columns"\n      ref="list">\n      <div\n        class="empty-state add-issues-empty-state-filter text-center"\n        v-if="issuesCount > 0 && issues.length === 0">\n        <div\n          class="svg-content"\n          v-html="image">\n        </div>\n        <div class="text-content">\n          <h4>\n            There are no issues to show.\n          </h4>\n        </div>\n      </div>\n      <div\n        v-for="group in groupedIssues"\n        class="add-issues-list-column">\n        <div\n          v-for="issue in group"\n          v-if="showIssue(issue)"\n          class="card-parent">\n          <div\n            class="card"\n            :class="{ \'is-active\': issue.selected }"\n            @click="toggleIssue($event, issue)">\n            <issue-card-inner\n              :issue="issue"\n              :issue-link-base="issueLinkBase"\n              :root-path="rootPath">\n            </issue-card-inner>\n            <span\n              :aria-label="\'Issue #\' + issue.id + \' selected\'"\n              aria-checked="true"\n              v-if="issue.selected"\n              class="issue-card-selected text-center">\n              <i class="fa fa-check"></i>\n            </span>\n          </div>\n        </div>\n      </div>\n    </section>\n  '
});

/***/ }),

/***/ "TQdT":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable no-unused-vars, no-mixed-operators, comma-dangle */
/* global DocumentTouch */

window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.onStart = function () {
  $('.has-tooltip').tooltip('hide').tooltip('disable');
  document.body.classList.add('is-dragging');
};

gl.issueBoards.onEnd = function () {
  $('.has-tooltip').tooltip('enable');
  document.body.classList.remove('is-dragging');
};

gl.issueBoards.touchEnabled = 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch;

gl.issueBoards.getBoardSortableDefaultOptions = function (obj) {
  var defaultSortOptions = {
    animation: 200,
    forceFallback: true,
    fallbackClass: 'is-dragging',
    fallbackOnBody: true,
    ghostClass: 'is-ghost',
    filter: '.board-delete, .btn',
    delay: gl.issueBoards.touchEnabled ? 100 : 0,
    scrollSensitivity: gl.issueBoards.touchEnabled ? 60 : 100,
    scrollSpeed: 20,
    onStart: gl.issueBoards.onStart,
    onEnd: gl.issueBoards.onEnd
  };

  Object.keys(obj).forEach(function (key) {
    defaultSortOptions[key] = obj[key];
  });
  return defaultSortOptions;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "VVVP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");


var ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalFooterListsDropdown = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  data: function data() {
    return {
      modal: ModalStore.store,
      state: gl.issueBoards.BoardsStore.state
    };
  },

  computed: {
    selected: function selected() {
      return this.modal.selectedList || this.state.lists[0];
    }
  },
  destroyed: function destroyed() {
    this.modal.selectedList = null;
  },

  template: '\n    <div class="dropdown inline">\n      <button\n        class="dropdown-menu-toggle"\n        type="button"\n        data-toggle="dropdown"\n        aria-expanded="false">\n        <span\n          class="dropdown-label-box"\n          :style="{ backgroundColor: selected.label.color }">\n        </span>\n        {{ selected.title }}\n        <i class="fa fa-chevron-down"></i>\n      </button>\n      <div class="dropdown-menu dropdown-menu-selectable dropdown-menu-drop-up">\n        <ul>\n          <li\n            v-for="list in state.lists"\n            v-if="list.type == \'label\'">\n            <a\n              href="#"\n              role="button"\n              :class="{ \'is-active\': list.id == selected.id }"\n              @click.prevent="modal.selectedList = list">\n              <span\n                class="dropdown-label-box"\n                :style="{ backgroundColor: list.label.color }">\n              </span>\n              {{ list.title }}\n            </a>\n          </li>\n        </ul>\n      </div>\n    </div>\n  '
});

/***/ }),

/***/ "Xfhe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-unused-vars, space-before-function-paren, arrow-body-style, arrow-parens, comma-dangle, max-len */
/* global ListLabel */
/* global ListMilestone */
/* global ListAssignee */



var ListIssue = function () {
  function ListIssue(obj, defaultAvatar) {
    var _this = this;

    _classCallCheck(this, ListIssue);

    this.globalId = obj.id;
    this.id = obj.iid;
    this.title = obj.title;
    this.confidential = obj.confidential;
    this.dueDate = obj.due_date;
    this.subscribed = obj.subscribed;
    this.labels = [];
    this.assignees = [];
    this.selected = false;
    this.position = obj.relative_position || Infinity;

    if (obj.milestone) {
      this.milestone = new ListMilestone(obj.milestone);
    }

    obj.labels.forEach(function (label) {
      _this.labels.push(new ListLabel(label));
    });

    this.assignees = obj.assignees.map(function (a) {
      return new ListAssignee(a, defaultAvatar);
    });
  }

  _createClass(ListIssue, [{
    key: 'addLabel',
    value: function addLabel(label) {
      if (!this.findLabel(label)) {
        this.labels.push(new ListLabel(label));
      }
    }
  }, {
    key: 'findLabel',
    value: function findLabel(_findLabel) {
      return this.labels.filter(function (label) {
        return label.title === _findLabel.title;
      })[0];
    }
  }, {
    key: 'removeLabel',
    value: function removeLabel(_removeLabel) {
      if (_removeLabel) {
        this.labels = this.labels.filter(function (label) {
          return _removeLabel.title !== label.title;
        });
      }
    }
  }, {
    key: 'removeLabels',
    value: function removeLabels(labels) {
      labels.forEach(this.removeLabel.bind(this));
    }
  }, {
    key: 'addAssignee',
    value: function addAssignee(assignee) {
      if (!this.findAssignee(assignee)) {
        this.assignees.push(new ListAssignee(assignee));
      }
    }
  }, {
    key: 'findAssignee',
    value: function findAssignee(_findAssignee) {
      return this.assignees.filter(function (assignee) {
        return assignee.id === _findAssignee.id;
      })[0];
    }
  }, {
    key: 'removeAssignee',
    value: function removeAssignee(_removeAssignee) {
      if (_removeAssignee) {
        this.assignees = this.assignees.filter(function (assignee) {
          return assignee.id !== _removeAssignee.id;
        });
      }
    }
  }, {
    key: 'removeAllAssignees',
    value: function removeAllAssignees() {
      this.assignees = [];
    }
  }, {
    key: 'getLists',
    value: function getLists() {
      var _this2 = this;

      return gl.issueBoards.BoardsStore.state.lists.filter(function (list) {
        return list.findIssue(_this2.id);
      });
    }
  }, {
    key: 'update',
    value: function update(url) {
      var data = {
        issue: {
          milestone_id: this.milestone ? this.milestone.id : null,
          due_date: this.dueDate,
          assignee_ids: this.assignees.length > 0 ? this.assignees.map(function (u) {
            return u.id;
          }) : [0],
          label_ids: this.labels.map(function (label) {
            return label.id;
          })
        }
      };

      if (!data.issue.label_ids.length) {
        data.issue.label_ids = [''];
      }

      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(url, data);
    }
  }]);

  return ListIssue;
}();

window.ListIssue = ListIssue;

/***/ }),

/***/ "Zuh3":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-unused-vars */

var ListAssignee = function ListAssignee(user, defaultAvatar) {
  _classCallCheck(this, ListAssignee);

  this.id = user.id;
  this.name = user.name;
  this.username = user.username;
  this.avatar = user.avatar_url || defaultAvatar;
};

window.ListAssignee = ListAssignee;

/***/ }),

/***/ "aKLL":
/***/ (function(module, exports) {

var ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalMixins = {
  methods: {
    toggleModal: function toggleModal(toggle) {
      ModalStore.store.showAddIssuesModal = toggle;
    },
    changeTab: function changeTab(tab) {
      ModalStore.store.activeTab = tab;
    }
  }
};

/***/ }),

/***/ "dzNA":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable comma-dangle, func-names, no-new, space-before-function-paren, one-var,
   promise/catch-or-return */

window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

var Store = gl.issueBoards.BoardsStore;

$(document).off('created.label').on('created.label', function (e, label) {
  Store.new({
    title: label.title,
    position: Store.state.lists.length - 2,
    list_type: 'label',
    label: {
      id: label.id,
      title: label.title,
      color: label.color
    }
  });
});

gl.issueBoards.newListDropdownInit = function () {
  $('.js-new-board-list').each(function () {
    var $this = $(this);
    new gl.CreateLabelDropdown($this.closest('.dropdown').find('.dropdown-new-label'), $this.data('namespace-path'), $this.data('project-path'));

    $this.glDropdown({
      data: function data(term, callback) {
        $.get($this.attr('data-labels')).then(function (resp) {
          callback(resp);
        });
      },
      renderRow: function renderRow(label) {
        var active = Store.findList('title', label.title);
        var $li = $('<li />');
        var $a = $('<a />', {
          class: active ? 'is-active js-board-list-' + active.id : '',
          text: label.title,
          href: '#'
        });
        var $labelColor = $('<span />', {
          class: 'dropdown-label-box',
          style: 'background-color: ' + label.color
        });

        return $li.append($a.prepend($labelColor));
      },

      search: {
        fields: ['title']
      },
      filterable: true,
      selectable: true,
      multiSelect: true,
      clicked: function clicked(options) {
        var e = options.e;

        var label = options.selectedObj;
        e.preventDefault();

        if (!Store.findList('title', label.title)) {
          Store.new({
            title: label.title,
            position: Store.state.lists.length - 2,
            list_type: 'label',
            label: {
              id: label.id,
              title: label.title,
              color: label.color
            }
          });

          Store.state.lists = _.sortBy(Store.state.lists, 'position');
        }
      }
    });
  });
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "eqGL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");


var ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalEmptyState = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  mixins: [gl.issueBoards.ModalMixins],
  data: function data() {
    return ModalStore.store;
  },

  props: {
    image: {
      type: String,
      required: true
    },
    newIssuePath: {
      type: String,
      required: true
    }
  },
  computed: {
    contents: function contents() {
      var obj = {
        title: 'You haven\'t added any issues to your project yet',
        content: '\n          An issue can be a bug, a todo or a feature request that needs to be\n          discussed in a project. Besides, issues are searchable and filterable.\n        '
      };

      if (this.activeTab === 'selected') {
        obj.title = 'You haven\'t selected any issues yet';
        obj.content = '\n          Go back to <strong>Open issues</strong> and select some issues\n          to add to your board.\n        ';
      }

      return obj;
    }
  },
  template: '\n    <section class="empty-state">\n      <div class="row">\n        <div class="col-xs-12 col-sm-6 col-sm-push-6">\n          <aside class="svg-content" v-html="image"></aside>\n        </div>\n        <div class="col-xs-12 col-sm-6 col-sm-pull-6">\n          <div class="text-content">\n            <h4>{{ contents.title }}</h4>\n            <p v-html="contents.content"></p>\n            <a\n              :href="newIssuePath"\n              class="btn btn-success btn-inverted"\n              v-if="activeTab === \'all\'">\n              New issue\n            </a>\n            <button\n              type="button"\n              class="btn btn-default"\n              @click="changeTab(\'all\')"\n              v-if="activeTab === \'selected\'">\n              Open issues\n            </button>\n          </div>\n        </div>\n      </div>\n    </section>\n  '
});

/***/ }),

/***/ "f7wA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("yoQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* eslint-disable comma-dangle, space-before-function-paren, one-var, no-shadow, dot-notation, max-len */
/* global List */



window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.BoardsStore = {
  disabled: false,
  filter: {
    path: ''
  },
  state: {},
  detail: {
    issue: {}
  },
  moving: {
    issue: {},
    list: {}
  },
  create: function create() {
    this.state.lists = [];
    this.filter.path = gl.utils.getUrlParamsArray().join('&');
  },
  addList: function addList(listObj, defaultAvatar) {
    var list = new List(listObj, defaultAvatar);
    this.state.lists.push(list);

    return list;
  },
  new: function _new(listObj) {
    var _this = this;

    var list = this.addList(listObj);

    list.save().then(function () {
      _this.state.lists = _.sortBy(_this.state.lists, 'position');
    }).catch(function () {
      // https://gitlab.com/gitlab-org/gitlab-ce/issues/30821
    });
    this.removeBlankState();
  },
  updateNewListDropdown: function updateNewListDropdown(listId) {
    $('.js-board-list-' + listId).removeClass('is-active');
  },
  shouldAddBlankState: function shouldAddBlankState() {
    // Decide whether to add the blank state
    return !this.state.lists.filter(function (list) {
      return list.type !== 'closed';
    })[0];
  },
  addBlankState: function addBlankState() {
    if (!this.shouldAddBlankState() || this.welcomeIsHidden() || this.disabled) return;

    this.addList({
      id: 'blank',
      list_type: 'blank',
      title: 'Welcome to your Issue Board!',
      position: 0
    });

    this.state.lists = _.sortBy(this.state.lists, 'position');
  },
  removeBlankState: function removeBlankState() {
    this.removeList('blank');

    __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('issue_board_welcome_hidden', 'true', {
      expires: 365 * 10,
      path: ''
    });
  },
  welcomeIsHidden: function welcomeIsHidden() {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('issue_board_welcome_hidden') === 'true';
  },
  removeList: function removeList(id) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blank';

    var list = this.findList('id', id, type);

    if (!list) return;

    this.state.lists = this.state.lists.filter(function (list) {
      return list.id !== id;
    });
  },
  moveList: function moveList(listFrom, orderLists) {
    var _this2 = this;

    orderLists.forEach(function (id, i) {
      var list = _this2.findList('id', parseInt(id, 10));

      list.position = i;
    });
    listFrom.update();
  },
  moveIssueToList: function moveIssueToList(listFrom, listTo, issue, newIndex) {
    var issueTo = listTo.findIssue(issue.id);
    var issueLists = issue.getLists();
    var listLabels = issueLists.map(function (listIssue) {
      return listIssue.label;
    });

    if (!issueTo) {
      // Add to new lists issues if it doesn't already exist
      listTo.addIssue(issue, listFrom, newIndex);
    } else {
      listTo.updateIssueLabel(issue, listFrom);
      issueTo.removeLabel(listFrom.label);
    }

    if (listTo.type === 'closed') {
      issueLists.forEach(function (list) {
        list.removeIssue(issue);
      });
      issue.removeLabels(listLabels);
    } else {
      listFrom.removeIssue(issue);
    }
  },
  moveIssueInList: function moveIssueInList(list, issue, oldIndex, newIndex, idArray) {
    var beforeId = parseInt(idArray[newIndex - 1], 10) || null;
    var afterId = parseInt(idArray[newIndex + 1], 10) || null;

    list.moveIssue(issue, oldIndex, newIndex, beforeId, afterId);
  },
  findList: function findList(key, val) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'label';

    return this.state.lists.filter(function (list) {
      var byType = type ? list['type'] === type : true;

      return list[key] === val && byType;
    })[0];
  },
  updateFiltersUrl: function updateFiltersUrl() {
    history.pushState(null, null, '?' + this.filter.path);
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "iqJG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* eslint-disable no-new */
/* global Flash */



__webpack_require__("VVVP");

var ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalFooter = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  mixins: [gl.issueBoards.ModalMixins],
  data: function data() {
    return {
      modal: ModalStore.store,
      state: gl.issueBoards.BoardsStore.state
    };
  },

  computed: {
    submitDisabled: function submitDisabled() {
      return !ModalStore.selectedCount();
    },
    submitText: function submitText() {
      var count = ModalStore.selectedCount();

      return 'Add ' + (count > 0 ? count : '') + ' ' + gl.text.pluralize('issue', count);
    }
  },
  methods: {
    addIssues: function addIssues() {
      var list = this.modal.selectedList || this.state.lists[0];
      var selectedIssues = ModalStore.getSelectedIssues();
      var issueIds = selectedIssues.map(function (issue) {
        return issue.globalId;
      });

      // Post the data to the backend
      gl.boardService.bulkUpdate(issueIds, {
        add_label_ids: [list.label.id]
      }).catch(function () {
        new Flash('Failed to update issues, please try again.', 'alert');

        selectedIssues.forEach(function (issue) {
          list.removeIssue(issue);
          list.issuesSize -= 1;
        });
      });

      // Add the issues on the frontend
      selectedIssues.forEach(function (issue) {
        list.addIssue(issue);
        list.issuesSize += 1;
      });

      this.toggleModal(false);
    }
  },
  components: {
    'lists-dropdown': gl.issueBoards.ModalFooterListsDropdown
  },
  template: '\n    <footer\n      class="form-actions add-issues-footer">\n      <div class="pull-left">\n        <button\n          class="btn btn-success"\n          type="button"\n          :disabled="submitDisabled"\n          @click="addIssues">\n          {{ submitText }}\n        </button>\n        <span class="inline add-issues-footer-to-list">\n          to list\n        </span>\n        <lists-dropdown></lists-dropdown>\n      </div>\n      <button\n        class="btn btn-default pull-right"\n        type="button"\n        @click="toggleModal(false)">\n        Cancel\n      </button>\n    </footer>\n  '
});

/***/ }),

/***/ "lgdU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_query_data__ = __webpack_require__("AN7F");
/* global ListIssue */




__webpack_require__("AX9H");
__webpack_require__("Pn7F");
__webpack_require__("iqJG");
__webpack_require__("eqGL");

var ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.IssuesModal = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    blankStateImage: {
      type: String,
      required: true
    },
    newIssuePath: {
      type: String,
      required: true
    },
    issueLinkBase: {
      type: String,
      required: true
    },
    rootPath: {
      type: String,
      required: true
    },
    projectId: {
      type: Number,
      required: true
    },
    milestonePath: {
      type: String,
      required: true
    },
    labelPath: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return ModalStore.store;
  },

  watch: {
    page: function page() {
      this.loadIssues();
    },
    showAddIssuesModal: function showAddIssuesModal() {
      var _this = this;

      if (this.showAddIssuesModal && !this.issues.length) {
        this.loading = true;
        var loadingDone = function loadingDone() {
          _this.loading = false;
        };

        this.loadIssues().then(loadingDone).catch(loadingDone);
      } else if (!this.showAddIssuesModal) {
        this.issues = [];
        this.selectedIssues = [];
        this.issuesCount = false;
      }
    },

    filter: {
      handler: function handler() {
        var _this2 = this;

        if (this.$el.tagName) {
          this.page = 1;
          this.filterLoading = true;
          var loadingDone = function loadingDone() {
            _this2.filterLoading = false;
          };

          this.loadIssues(true).then(loadingDone).catch(loadingDone);
        }
      },

      deep: true
    }
  },
  methods: {
    loadIssues: function loadIssues() {
      var _this3 = this;

      var clearIssues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.showAddIssuesModal) return false;

      return gl.boardService.getBacklog(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_query_data__["a" /* default */])(this.filter.path, {
        page: this.page,
        per: this.perPage
      })).then(function (res) {
        var data = res.json();

        if (clearIssues) {
          _this3.issues = [];
        }

        data.issues.forEach(function (issueObj) {
          var issue = new ListIssue(issueObj);
          var foundSelectedIssue = ModalStore.findSelectedIssue(issue);
          issue.selected = !!foundSelectedIssue;

          _this3.issues.push(issue);
        });

        _this3.loadingNewPage = false;

        if (!_this3.issuesCount) {
          _this3.issuesCount = data.size;
        }
      }).catch(function () {
        // TODO: handle request error
      });
    }
  },
  computed: {
    showList: function showList() {
      if (this.activeTab === 'selected') {
        return this.selectedIssues.length > 0;
      }

      return this.issuesCount > 0;
    },
    showEmptyState: function showEmptyState() {
      if (!this.loading && this.issuesCount === 0) {
        return true;
      }

      return this.activeTab === 'selected' && this.selectedIssues.length === 0;
    }
  },
  created: function created() {
    this.page = 1;
  },

  components: {
    'modal-header': gl.issueBoards.ModalHeader,
    'modal-list': gl.issueBoards.ModalList,
    'modal-footer': gl.issueBoards.ModalFooter,
    'empty-state': gl.issueBoards.ModalEmptyState
  },
  template: '\n    <div\n      class="add-issues-modal"\n      v-if="showAddIssuesModal">\n      <div class="add-issues-container">\n        <modal-header\n          :project-id="projectId"\n          :milestone-path="milestonePath"\n          :label-path="labelPath">\n        </modal-header>\n        <modal-list\n          :image="blankStateImage"\n          :issue-link-base="issueLinkBase"\n          :root-path="rootPath"\n          v-if="!loading && showList && !filterLoading"></modal-list>\n        <empty-state\n          v-if="showEmptyState"\n          :image="blankStateImage"\n          :new-issue-path="newIssuePath"></empty-state>\n        <section\n          class="add-issues-list text-center"\n          v-if="loading || filterLoading">\n          <div class="add-issues-list-loading">\n            <i class="fa fa-spinner fa-spin"></i>\n          </div>\n        </section>\n        <modal-footer></modal-footer>\n      </div>\n    </div>\n  '
});

/***/ }),

/***/ "p52B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]());

/***/ }),

/***/ "pXFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eventhub__ = __webpack_require__("p52B");



var Store = gl.issueBoards.BoardsStore;

window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.IssueCardInner = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    issue: {
      type: Object,
      required: true
    },
    issueLinkBase: {
      type: String,
      required: true
    },
    list: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    rootPath: {
      type: String,
      required: true
    },
    updateFilters: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      limitBeforeCounter: 3,
      maxRender: 4,
      maxCounter: 99
    };
  },

  computed: {
    numberOverLimit: function numberOverLimit() {
      return this.issue.assignees.length - this.limitBeforeCounter;
    },
    assigneeCounterTooltip: function assigneeCounterTooltip() {
      return this.assigneeCounterLabel + ' more';
    },
    assigneeCounterLabel: function assigneeCounterLabel() {
      if (this.numberOverLimit > this.maxCounter) {
        return this.maxCounter + '+';
      }

      return '+' + this.numberOverLimit;
    },
    shouldRenderCounter: function shouldRenderCounter() {
      if (this.issue.assignees.length <= this.maxRender) {
        return false;
      }

      return this.issue.assignees.length > this.numberOverLimit;
    },
    cardUrl: function cardUrl() {
      return this.issueLinkBase + '/' + this.issue.id;
    },
    issueId: function issueId() {
      return '#' + this.issue.id;
    },
    showLabelFooter: function showLabelFooter() {
      var _this = this;

      return this.issue.labels.find(function (l) {
        return _this.showLabel(l);
      }) !== undefined;
    }
  },
  methods: {
    isIndexLessThanlimit: function isIndexLessThanlimit(index) {
      return index < this.limitBeforeCounter;
    },
    shouldRenderAssignee: function shouldRenderAssignee(index) {
      // Eg. maxRender is 4,
      // Render up to all 4 assignees if there are only 4 assigness
      // Otherwise render up to the limitBeforeCounter
      if (this.issue.assignees.length <= this.maxRender) {
        return index < this.maxRender;
      }

      return index < this.limitBeforeCounter;
    },
    assigneeUrl: function assigneeUrl(assignee) {
      return '' + this.rootPath + assignee.username;
    },
    assigneeUrlTitle: function assigneeUrlTitle(assignee) {
      return 'Assigned to ' + assignee.name;
    },
    avatarUrlTitle: function avatarUrlTitle(assignee) {
      return 'Avatar for ' + assignee.name;
    },
    showLabel: function showLabel(label) {
      if (!this.list) return true;

      return !this.list.label || label.id !== this.list.label.id;
    },
    filterByLabel: function filterByLabel(label, e) {
      if (!this.updateFilters) return;

      var filterPath = gl.issueBoards.BoardsStore.filter.path.split('&');
      var labelTitle = encodeURIComponent(label.title);
      var param = 'label_name[]=' + labelTitle;
      var labelIndex = filterPath.indexOf(param);
      $(e.currentTarget).tooltip('hide');

      if (labelIndex === -1) {
        filterPath.push(param);
      } else {
        filterPath.splice(labelIndex, 1);
      }

      gl.issueBoards.BoardsStore.filter.path = filterPath.join('&');

      Store.updateFiltersUrl();

      __WEBPACK_IMPORTED_MODULE_1__eventhub__["a" /* default */].$emit('updateTokens');
    },
    labelStyle: function labelStyle(label) {
      return {
        backgroundColor: label.color,
        color: label.textColor
      };
    }
  },
  template: '\n    <div>\n      <div class="card-header">\n        <h4 class="card-title">\n          <i\n            class="fa fa-eye-slash confidential-icon"\n            v-if="issue.confidential"\n            aria-hidden="true"\n          />\n          <a\n            class="js-no-trigger"\n            :href="cardUrl"\n            :title="issue.title">{{ issue.title }}</a>\n          <span\n            class="card-number"\n            v-if="issue.id"\n          >\n            {{ issueId }}\n          </span>\n        </h4>\n        <div class="card-assignee">\n          <a\n            class="has-tooltip js-no-trigger"\n            :href="assigneeUrl(assignee)"\n            :title="assigneeUrlTitle(assignee)"\n            v-for="(assignee, index) in issue.assignees"\n            v-if="shouldRenderAssignee(index)"\n            data-container="body"\n            data-placement="bottom"\n          >\n            <img\n              class="avatar avatar-inline s20"\n              :src="assignee.avatar"\n              width="20"\n              height="20"\n              :alt="avatarUrlTitle(assignee)"\n            />\n          </a>\n          <span\n            class="avatar-counter has-tooltip"\n            :title="assigneeCounterTooltip"\n            v-if="shouldRenderCounter"\n          >\n           {{ assigneeCounterLabel }}\n          </span>\n        </div>\n      </div>\n      <div\n        class="card-footer"\n        v-if="showLabelFooter"\n      >\n        <button\n          class="label color-label has-tooltip"\n          v-for="label in issue.labels"\n          type="button"\n          v-if="showLabel(label)"\n          @click="filterByLabel(label, $event)"\n          :style="labelStyle(label)"\n          :title="label.description"\n          data-container="body">\n          {{ label.title }}\n        </button>\n      </div>\n    </div>\n  '
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "q4Fq":
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

var ModalStore = function () {
  function ModalStore() {
    _classCallCheck(this, ModalStore);

    this.store = {
      columns: 3,
      issues: [],
      issuesCount: false,
      selectedIssues: [],
      showAddIssuesModal: false,
      activeTab: 'all',
      selectedList: null,
      searchTerm: '',
      loading: false,
      loadingNewPage: false,
      filterLoading: false,
      page: 1,
      perPage: 50,
      filter: {
        path: ''
      }
    };
  }

  _createClass(ModalStore, [{
    key: 'selectedCount',
    value: function selectedCount() {
      return this.getSelectedIssues().length;
    }
  }, {
    key: 'toggleIssue',
    value: function toggleIssue(issueObj) {
      var issue = issueObj;
      var selected = issue.selected;

      issue.selected = !selected;

      if (!selected) {
        this.addSelectedIssue(issue);
      } else {
        this.removeSelectedIssue(issue);
      }
    }
  }, {
    key: 'toggleAll',
    value: function toggleAll() {
      var _this = this;

      var select = this.selectedCount() !== this.store.issues.length;

      this.store.issues.forEach(function (issue) {
        var issueUpdate = issue;

        if (issueUpdate.selected !== select) {
          issueUpdate.selected = select;

          if (select) {
            _this.addSelectedIssue(issue);
          } else {
            _this.removeSelectedIssue(issue);
          }
        }
      });
    }
  }, {
    key: 'getSelectedIssues',
    value: function getSelectedIssues() {
      return this.store.selectedIssues.filter(function (issue) {
        return issue.selected;
      });
    }
  }, {
    key: 'addSelectedIssue',
    value: function addSelectedIssue(issue) {
      var index = this.selectedIssueIndex(issue);

      if (index === -1) {
        this.store.selectedIssues.push(issue);
      }
    }
  }, {
    key: 'removeSelectedIssue',
    value: function removeSelectedIssue(issue) {
      var forcePurge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.store.activeTab === 'all' || forcePurge) {
        this.store.selectedIssues = this.store.selectedIssues.filter(function (fIssue) {
          return fIssue.id !== issue.id;
        });
      }
    }
  }, {
    key: 'purgeUnselectedIssues',
    value: function purgeUnselectedIssues() {
      var _this2 = this;

      this.store.selectedIssues.forEach(function (issue) {
        if (!issue.selected) {
          _this2.removeSelectedIssue(issue, true);
        }
      });
    }
  }, {
    key: 'selectedIssueIndex',
    value: function selectedIssueIndex(issue) {
      return this.store.selectedIssues.indexOf(issue);
    }
  }, {
    key: 'findSelectedIssue',
    value: function findSelectedIssue(issue) {
      return this.store.selectedIssues.filter(function (filteredIssue) {
        return filteredIssue.id === issue.id;
      })[0];
    }
  }]);

  return ModalStore;
}();

gl.issueBoards.ModalStore = new ModalStore();

/***/ }),

/***/ "qMC/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* global dateFormat */



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('due-date', function (value) {
  var date = new Date(value);
  return dateFormat(date, 'mmm d, yyyy', true);
});

/***/ }),

/***/ "qqgg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__("pXFb");

var Store = gl.issueBoards.BoardsStore;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BoardsIssueCard',
  template: '\n    <li class="card"\n      :class="{ \'user-can-drag\': !disabled && issue.id, \'is-disabled\': disabled || !issue.id, \'is-active\': issueDetailVisible }"\n      :index="index"\n      :data-issue-id="issue.id"\n      @mousedown="mouseDown"\n      @mousemove="mouseMove"\n      @mouseup="showIssue($event)">\n      <issue-card-inner\n        :list="list"\n        :issue="issue"\n        :issue-link-base="issueLinkBase"\n        :root-path="rootPath"\n        :update-filters="true" />\n    </li>\n  ',
  components: {
    'issue-card-inner': gl.issueBoards.IssueCardInner
  },
  props: {
    list: Object,
    issue: Object,
    issueLinkBase: String,
    disabled: Boolean,
    index: Number,
    rootPath: String
  },
  data: function data() {
    return {
      showDetail: false,
      detailIssue: Store.detail
    };
  },

  computed: {
    issueDetailVisible: function issueDetailVisible() {
      return this.detailIssue.issue && this.detailIssue.issue.id === this.issue.id;
    }
  },
  methods: {
    mouseDown: function mouseDown() {
      this.showDetail = true;
    },
    mouseMove: function mouseMove() {
      this.showDetail = false;
    },
    showIssue: function showIssue(e) {
      if (e.target.classList.contains('js-no-trigger')) return;

      if (this.showDetail) {
        this.showDetail = false;

        if (Store.detail.issue && Store.detail.issue.id === this.issue.id) {
          Store.detail.issue = {};
        } else {
          Store.detail.issue = this.issue;
          Store.detail.list = this.list;
        }
      }
    }
  }
});

/***/ }),

/***/ "rFKb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filtered_search_boards__ = __webpack_require__("s61N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filtered_search_container__ = __webpack_require__("9/oB");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-filters',
  props: {
    store: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__filtered_search_container__["a" /* default */].container = this.$el;

    this.filteredSearch = new __WEBPACK_IMPORTED_MODULE_0__filtered_search_boards__["a" /* default */](this.store);
    this.filteredSearch.removeTokens();
    this.filteredSearch.handleInputPlaceholder();
    this.filteredSearch.toggleClearSearchButton();
  },
  destroyed: function destroyed() {
    this.filteredSearch.cleanup();
    __WEBPACK_IMPORTED_MODULE_1__filtered_search_container__["a" /* default */].container = document;
    this.store.path = '';
  },

  template: '#js-board-modal-filter'
});

/***/ }),

/***/ "rP25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("yoQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* global ListLabel */



var Store = gl.issueBoards.BoardsStore;

/* harmony default export */ __webpack_exports__["a"] = ({
  template: '\n    <div class="board-blank-state">\n      <p>\n        Add the following default lists to your Issue Board with one click:\n      </p>\n      <ul class="board-blank-state-list">\n        <li v-for="label in predefinedLabels">\n          <span\n            class="label-color"\n            :style="{ backgroundColor: label.color }">\n          </span>\n          {{ label.title }}\n        </li>\n      </ul>\n      <p>\n        Starting out with the default set of lists will get you right on the way to making the most of your board.\n      </p>\n      <button\n        class="btn btn-create btn-inverted btn-block"\n        type="button"\n        @click.stop="addDefaultLists">\n        Add default lists\n      </button>\n      <button\n        class="btn btn-default btn-block"\n        type="button"\n        @click.stop="clearBlankState">\n        Nevermind, I\'ll use my own\n      </button>\n    </div>\n  ',
  data: function data() {
    return {
      predefinedLabels: [new ListLabel({ title: 'To Do', color: '#F0AD4E' }), new ListLabel({ title: 'Doing', color: '#5CB85C' })]
    };
  },

  methods: {
    addDefaultLists: function addDefaultLists() {
      this.clearBlankState();

      this.predefinedLabels.forEach(function (label, i) {
        Store.addList({
          title: label.title,
          position: i,
          list_type: 'label',
          label: {
            title: label.title,
            color: label.color
          }
        });
      });

      Store.state.lists = _.sortBy(Store.state.lists, 'position');

      // Save the labels
      gl.boardService.generateDefaultLists().then(function (resp) {
        resp.json().forEach(function (listObj) {
          var list = Store.findList('title', listObj.title);

          list.id = listObj.id;
          list.label.id = listObj.label.id;
          list.getIssues().catch(function () {
            // TODO: handle request error
          });
        });
      }).catch(function () {
        Store.removeList(undefined, 'label');
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove('issue_board_welcome_hidden', {
          path: ''
        });
        Store.addBlankState();
      });
    },

    clearBlankState: Store.removeBlankState.bind(Store)
  }
});

/***/ }),

/***/ "s61N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filtered_search_container__ = __webpack_require__("9/oB");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable class-methods-use-this */


var FilteredSearchBoards = function (_gl$FilteredSearchMan) {
  _inherits(FilteredSearchBoards, _gl$FilteredSearchMan);

  function FilteredSearchBoards(store) {
    var updateUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, FilteredSearchBoards);

    var _this = _possibleConstructorReturn(this, (FilteredSearchBoards.__proto__ || Object.getPrototypeOf(FilteredSearchBoards)).call(this, 'boards'));

    _this.store = store;
    _this.updateUrl = updateUrl;

    // Issue boards is slightly different, we handle all the requests async
    // instead or reloading the page, we just re-fire the list ajax requests
    _this.isHandledAsync = true;
    return _this;
  }

  _createClass(FilteredSearchBoards, [{
    key: 'updateObject',
    value: function updateObject(path) {
      this.store.path = path.substr(1);

      if (this.updateUrl) {
        gl.issueBoards.BoardsStore.updateFiltersUrl();
      }
    }
  }, {
    key: 'removeTokens',
    value: function removeTokens() {
      var tokens = __WEBPACK_IMPORTED_MODULE_0__filtered_search_container__["a" /* default */].container.querySelectorAll('.js-visual-token');

      // Remove all the tokens as they will be replaced by the search manager
      [].forEach.call(tokens, function (el) {
        el.parentNode.removeChild(el);
      });

      this.filteredSearchInput.value = '';
    }
  }, {
    key: 'updateTokens',
    value: function updateTokens() {
      this.removeTokens();

      this.loadSearchParamsFromURL();

      // Get the placeholder back if search is empty
      this.filteredSearchInput.dispatchEvent(new Event('input'));
    }
  }]);

  return FilteredSearchBoards;
}(gl.FilteredSearchManager);

/* harmony default export */ __webpack_exports__["a"] = (FilteredSearchBoards);

/***/ }),

/***/ "unKI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* eslint-disable comma-dangle, space-before-function-paren, no-alert */



window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.BoardDelete = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    list: Object
  },
  methods: {
    deleteBoard: function deleteBoard() {
      $(this.$el).tooltip('hide');

      if (confirm('Are you sure you want to delete this list?')) {
        this.list.destroy();
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "ypBK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Assignees',
  data: function data() {
    return {
      defaultRenderCount: 5,
      defaultMaxCounter: 99,
      showLess: true
    };
  },

  props: {
    rootPath: {
      type: String,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    editable: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    firstUser: function firstUser() {
      return this.users[0];
    },
    hasMoreThanTwoAssignees: function hasMoreThanTwoAssignees() {
      return this.users.length > 2;
    },
    hasMoreThanOneAssignee: function hasMoreThanOneAssignee() {
      return this.users.length > 1;
    },
    hasAssignees: function hasAssignees() {
      return this.users.length > 0;
    },
    hasNoUsers: function hasNoUsers() {
      return !this.users.length;
    },
    hasOneUser: function hasOneUser() {
      return this.users.length === 1;
    },
    renderShowMoreSection: function renderShowMoreSection() {
      return this.users.length > this.defaultRenderCount;
    },
    numberOfHiddenAssignees: function numberOfHiddenAssignees() {
      return this.users.length - this.defaultRenderCount;
    },
    isHiddenAssignees: function isHiddenAssignees() {
      return this.numberOfHiddenAssignees > 0;
    },
    hiddenAssigneesLabel: function hiddenAssigneesLabel() {
      return '+ ' + this.numberOfHiddenAssignees + ' more';
    },
    collapsedTooltipTitle: function collapsedTooltipTitle() {
      var maxRender = Math.min(this.defaultRenderCount, this.users.length);
      var renderUsers = this.users.slice(0, maxRender);
      var names = renderUsers.map(function (u) {
        return u.name;
      });

      if (this.users.length > maxRender) {
        names.push('+ ' + (this.users.length - maxRender) + ' more');
      }

      return names.join(', ');
    },
    sidebarAvatarCounter: function sidebarAvatarCounter() {
      var counter = '+' + (this.users.length - 1);

      if (this.users.length > this.defaultMaxCounter) {
        counter = this.defaultMaxCounter + '+';
      }

      return counter;
    }
  },
  methods: {
    assignSelf: function assignSelf() {
      this.$emit('assign-self');
    },
    toggleShowLess: function toggleShowLess() {
      this.showLess = !this.showLess;
    },
    renderAssignee: function renderAssignee(index) {
      return !this.showLess || index < this.defaultRenderCount && this.showLess;
    },
    avatarUrl: function avatarUrl(user) {
      return user.avatar || user.avatar_url;
    },
    assigneeUrl: function assigneeUrl(user) {
      return '' + this.rootPath + user.username;
    },
    assigneeAlt: function assigneeAlt(user) {
      return user.name + '\'s avatar';
    },
    assigneeUsername: function assigneeUsername(user) {
      return '@' + user.username;
    },
    shouldRenderCollapsedAssignee: function shouldRenderCollapsedAssignee(index) {
      var firstTwo = this.users.length <= 2 && index <= 2;

      return index === 0 || firstTwo;
    }
  },
  template: '\n    <div>\n      <div\n        class="sidebar-collapsed-icon sidebar-collapsed-user"\n        :class="{ \'multiple-users\': hasMoreThanOneAssignee, \'has-tooltip\': hasAssignees }"\n        data-container="body"\n        data-placement="left"\n        :title="collapsedTooltipTitle"\n      >\n        <i\n          v-if="hasNoUsers"\n          aria-label="No Assignee"\n          class="fa fa-user"\n        />\n        <button\n          type="button"\n          class="btn-link"\n          v-for="(user, index) in users"\n          v-if="shouldRenderCollapsedAssignee(index)"\n        >\n          <img\n            width="24"\n            class="avatar avatar-inline s24"\n            :alt="assigneeAlt(user)"\n            :src="avatarUrl(user)"\n          />\n          <span class="author">\n            {{ user.name }}\n          </span>\n        </button>\n        <button\n          v-if="hasMoreThanTwoAssignees"\n          class="btn-link"\n          type="button"\n        >\n          <span\n            class="avatar-counter sidebar-avatar-counter"\n          >\n            {{ sidebarAvatarCounter }}\n          </span>\n        </button>\n      </div>\n      <div class="value hide-collapsed">\n        <template v-if="hasNoUsers">\n          <span class="assign-yourself no-value">\n            No assignee\n            <template v-if="editable">\n             -\n              <button\n                type="button"\n                class="btn-link"\n                @click="assignSelf"\n              >\n                assign yourself\n              </button>\n            </template>\n          </span>\n        </template>\n        <template v-else-if="hasOneUser">\n          <a\n            class="author_link bold"\n            :href="assigneeUrl(firstUser)"\n          >\n            <img\n              width="32"\n              class="avatar avatar-inline s32"\n              :alt="assigneeAlt(firstUser)"\n              :src="avatarUrl(firstUser)"\n            />\n            <span class="author">\n              {{ firstUser.name }}\n            </span>\n            <span class="username">\n              {{ assigneeUsername(firstUser) }}\n            </span>\n          </a>\n        </template>\n        <template v-else>\n          <div class="user-list">\n            <div\n              class="user-item"\n              v-for="(user, index) in users"\n              v-if="renderAssignee(index)"\n            >\n              <a\n                class="user-link has-tooltip"\n                data-placement="bottom"\n                :href="assigneeUrl(user)"\n                :data-title="user.name"\n              >\n                <img\n                  width="32"\n                  class="avatar avatar-inline s32"\n                  :alt="assigneeAlt(user)"\n                  :src="avatarUrl(user)"\n                />\n              </a>\n            </div>\n          </div>\n          <div\n            v-if="renderShowMoreSection"\n            class="user-list-more"\n          >\n            <button\n              type="button"\n              class="btn-link"\n              @click="toggleShowLess"\n            >\n              <template v-if="showLess">\n                {{ hiddenAssigneesLabel }}\n              </template>\n              <template v-else>\n                - show less\n              </template>\n            </button>\n          </div>\n        </template>\n      </div>\n    </div>\n  '
});

/***/ })

},["IyBU"]);


// WEBPACK FOOTER //
// boards.cde962929165793da0ab.bundle.js